export const mcsDefaultData = {
  MCS_flag: {
    value: null,
    __comment: "1:execute MCS, 0:without MCS",
  },
  number_of_samples: {
    value: null,
    __comment: "number of samples for MCS",
  },
  sigma_pos0: {
    value: null,
    __comment: "sigma for initial position",
  },
  sigma_vel0: {
    value: null,
    __comment: "sigma for initial velocity",
  },
  sigma_euler0: {
    value: null,
    __comment: "sigma for initial Euler angles",
  },
  sigma_omega0: {
    value: null,
    __comment: "sigma for initial angular rate",
  },
  sigma_m_dry: {
    value: null,
    __comment: "sigma for dry mass (within frame as ratio)",
  },
  sigma_m_propellant: {
    value: null,
    __comment: "sigma for propellant mass (within frame as ratio)",
  },
  sigma_CG_s: {
    value: null,
    __comment: "sigma for start CG",
  },
  sigma_CG_e: {
    value: null,
    __comment: "sigma for end CG",
  },
  sigma_I_s: {
    value: null,
    __comment: "sigma for start inertia tensor",
  },
  sigma_I_s_x: {
    value: null,
    __comment: "sigma for start inertia tensor",
  },
  sigma_I_s_y: {
    value: null,
    __comment: "sigma for start inertia tensor",
  },
  sigma_I_s_z: {
    value: null,
    __comment: "sigma for start inertia tensor",
  },
  sigma_I_e: {
    value: null,
    __comment: "sigma for end inertia tensor",
  },
  sigma_I_e_x: {
    value: null,
    __comment: "sigma for end inertia tensor",
  },
  sigma_I_e_y: {
    value: null,
    __comment: "sigma for end inertia tensor",
  },
  sigma_I_e_z: {
    value: null,
    __comment: "sigma for end inertia tensor",
  },
  sigma_CG_tank: {
    value: null,
    __comment: "sigma for tank CG",
  },
  sigma_pos_fuel_s: {
    value: null,
    __comment: "sigma for start fuel position",
  },
  sigma_pos_fuel_e: {
    value: null,
    __comment: "sigma for end fuel position",
  },
  sigma_CA_data: {
    value: null,
    __comment: "sigma for CA aerodynamic data",
  },
  sigma_CY_data: {
    value: null,
    __comment: "sigma for CY aerodynamic data",
  },
  sigma_CN_data: {
    value: null,
    __comment: "sigma for CN aerodynamic data",
  },
  sigma_Cl_data: {
    value: null,
    __comment: "sigma for Cl aerodynamic data",
  },
  sigma_Cm_data: {
    value: null,
    __comment: "sigma for Cm aerodynamic data",
  },
  sigma_Cn_data: {
    value: null,
    __comment: "sigma for Cn aerodynamic data",
  },
  sigma_Isp: {
    value: null,
    __comment: "sigma for specific impulse (within frame as ratio)",
  },
  sigma_thrust_max: {
    value: null,
    __comment: "sigma for max thrust (within frame as ratio)",
  },
  sigma_thrust_tau: {
    value: null,
    __comment: "sigma for thrust time constant (within frame as ratio)",
  },
  sigma_thrust_DT: {
    value: null,
    __comment: "sigma for thrust delay time (within frame as ratio)",
  },
  sigma_L_engine_pitch: {
    value: null,
    __comment: "sigma for engine pitch offset",
  },
  sigma_TVC1_pos: {
    value: null,
    __comment: "sigma for TVC1 position",
  },
  sigma_TVC2_pos: {
    value: null,
    __comment: "sigma for TVC2 position",
  },
  sigma_omega_c: {
    value: null,
    __comment: "sigma for control bandwidth (within frame as ratio)",
  },
  sigma_zeta: {
    value: null,
    __comment: "sigma for damping ratio (within frame as ratio)",
  },
  sigma_omega_T: {
    value: null,
    __comment: "sigma for time constant (within frame as ratio)",
  },
  sigma_TVC_max: {
    value: null,
    __comment: "sigma for maximum TVC angle",
  },
  sigma_TVC_min: {
    value: null,
    __comment: "sigma for minimum TVC angle",
  },
  sigma_TVC_rateLim: {
    value: null,
    __comment: "sigma for TVC rate limit",
  },
  sigma_Isp_RCS: {
    value: null,
    __comment: "sigma for RCS specific impulse (within frame as ratio)",
  },
  sigma_m_RCS: {
    value: null,
    __comment: "sigma for RCS mass (within frame as ratio)",
  },
  sigma_Fc: {
    value: null,
    __comment: "sigma for RCS thrust force (within frame as ratio)",
  },
  sigma_tau_RCS: {
    value: null,
    __comment: "sigma for RCS time constant (within frame as ratio)",
  },
  sigma_DT_RCS: {
    value: null,
    __comment: "sigma for RCS delay time (within frame as ratio)",
  },
  sigma_wind_speed: {
    value: null,
    __comment: "sigma for wind speed",
  },
  sigma_wind_direction: {
    value: null,
    __comment: "sigma for wind direction (0–360 range)",
  },
  sigma_max_acc: {
    value: null,
    __comment: "sigma for maximum accelerometer bias (within frame as ratio)",
  },
  sigma_LSB_acc: {
    value: null,
    __comment: "sigma for accelerometer LSB noise (within frame as ratio)",
  },
  sigma_RW_acc: {
    value: null,
    __comment: "sigma for random walk accel noise (within frame as ratio)",
  },
  sigma_BU_acc: {
    value: null,
    __comment: "sigma for bias instability accel (within frame as ratio)",
  },
  sigma_TB_acc: {
    value: null,
    __comment: "sigma for temperature bias accel (within frame as ratio)",
  },
  sigma_max_gyro: {
    value: null,
    __comment: "sigma for maximum gyro bias (within frame as ratio)",
  },
  sigma_LSB_gyro: {
    value: null,
    __comment: "sigma for gyro LSB noise (within frame as ratio)",
  },
  sigma_RW_gyro: {
    value: null,
    __comment: "sigma for random walk gyro noise (within frame as ratio)",
  },
  sigma_BU_gyro: {
    value: null,
    __comment: "sigma for bias instability gyro (within frame as ratio)",
  },
  sigma_TB_gyro: {
    value: null,
    __comment: "sigma for temperature bias gyro (within frame as ratio)",
  },
  sigma_skew: {
    value: null,
    __comment: "sigma for sensor skew (within frame as ratio)",
  },
  sigma_pos_err1: {
    value: null,
    __comment: "sigma for position error term 1 (within frame as ratio)",
  },
  sigma_pos_err2: {
    value: null,
    __comment: "sigma for position error term 2 (within frame as ratio)",
  },
  sigma_vel_err: {
    value: null,
    __comment: "sigma for velocity error (within frame as ratio)",
  },
  altitude_reference: {
    value: null,
    __comment: "Altitude reference for mcs",
  },
  east_reference: {
    value: null,
    __comment: "East-West reference for mcs",
  },
  north_reference: {
    value: null,
    __comment: "North-South reference for mcs",
  },
  vel_x_reference: {
    value: null,
    __comment: "Vertical velocity reference for mcs",
  },
  vel_y_reference: {
    value: null,
    __comment: "East-West velocity reference for mcs",
  },
  vel_z_reference: {
    value: null,
    __comment: "North-South velocity reference for mcs",
  },
  roll_reference: {
    value: null,
    __comment: "Roll reference for mcs",
  },
  pitch_reference: {
    value: null,
    __comment: "Pitch reference for mcs",
  },
  yaw_reference: {
    value: null,
    __comment: "Yaw reference for mcs",
  },
  roll_rate_reference: {
    value: null,
    __comment: "Roll rate reference for mcs",
  },
  pitch_rate_reference: {
    value: null,
    __comment: "Pitch rate reference for mcs",
  },
  yaw_rate_reference: {
    value: null,
    __comment: "Yaw rate reference for mcs",
  },
};
